import { FilaAtendimentoVistoria } from "./FilaAtendimentoVistoria";
import { MeusAtendimentosVistorias } from "./MeusAtendimentosVistoria";
import { TodosAtendimentosVistoria } from "./TodosAtendimentoVistoria";

export const GestaoAtendimentoVistoria = {
    TodosAtendimentosVistoria,
    MeusAtendimentosVistorias,
    FilaAtendimentoVistoria,
};
